import React, { useCallback } from 'react';
import MultiTaskResponse from 'react-scale/components/Task/MultiTaskResponse';
import { SubtaskAssignment } from './types';

import { Event } from '@scale/shared/types/events';
import {
  ElementClickedType,
  GeneralElementClicked,
} from '@scale/shared/types/events/GeneralElementClicked';
import { logCorpEvent } from '@scale/frontend-lib/analytics/log-corp-event';
import { SpeedAuditLookupResponse } from '@scale/shared/types/corp/attemptAudit';
import { withErrorBoundary } from 'react-scale/containers/global/errorBoundary';
import { ShortcutsProvider } from 'react-scale/hooks/useShortcut';

interface SpeedAuditDialogProps {
  subtaskAssignment: SubtaskAssignment;
  setSelectedAnnotation: (annotationId: string | undefined) => void;
  onNavChange?: (response: SpeedAuditLookupResponse, index: number) => void;
  showTaskerPane?: boolean;
}

const SpeedAuditMultiTaskResponseComponent = ({
  subtaskAssignment,
  setSelectedAnnotation,
  onNavChange,
  showTaskerPane,
}: SpeedAuditDialogProps) => {
  const handleIdSelect = useCallback(
    async (annotationId: string | null) => {
      setSelectedAnnotation(annotationId ?? undefined);
      return logCorpEvent(Event.GeneralElementClicked, {
        name: 'Speed Audit > Select attempt',
        type: ElementClickedType.Button,
      } as GeneralElementClicked);
    },
    [setSelectedAnnotation],
  );

  return (
    <ShortcutsProvider>
      <MultiTaskResponse
        key={subtaskAssignment.subtask.id}
        responses={subtaskAssignment.responses}
        subtask={subtaskAssignment.subtask}
        customDivHeight="80vh"
        handleIdSelect={handleIdSelect}
        isSpeedAudit={true}
        readOnly={true}
        onNavChange={onNavChange}
        showTaskerPane={showTaskerPane}
        hideLifetimeEarnings={true}
        showCalibrationFeedback={subtaskAssignment.subtask.isInstructionTask}
      />
    </ShortcutsProvider>
  );
};

export const SpeedAuditMultiTaskResponse = React.memo(
  withErrorBoundary({ reloadable: true })(SpeedAuditMultiTaskResponseComponent),
);
